import clsx from 'clsx';

type CloseIconProps = {
  className?: string;
  onClick: () => void;
};

export const CloseIcon: React.FC<CloseIconProps> = ({ className, onClick }) => (
  <svg
    width="32"
    height="32"
    fill="none"
    onClick={onClick}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'cursor-pointer')}
  >
    <path
      d="M22 22L10 10M22 10L10 22"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
